import React from 'react';

const RegistrationHeader = () => (
    <div className="registration-box-logo">
        <div className="registration-box-logo-text"><b>PreQualification</b></div>
        <img style={{ maxWidth: 250 }} className="registration-box-logo-img" src="/images/white_logo_nvbdc.png" alt="Dashboard" />
    </div>
)

export default RegistrationHeader;



// WEBPACK FOOTER //
// ./src/layouts/public/registrationHeader/RegistrationHeader.js